import { Component, ElementRef, ViewChild, AfterViewChecked, inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

interface Message {
  role: 'model' | 'user';
  text: string;
}

@Component({
  selector: 'app-chat-widget',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.css']
})
export class ChatWidgetComponent implements AfterViewChecked {
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;
  
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private cdr = inject(ChangeDetectorRef);
  private apiUrl = 'https://api.mesh-box.fr/api/chat'; 

  isOpen = false;
  messages: Message[] = [
    { role: 'model', text: "Bonjour ! Je suis l'assistant IA de Mesh Box. Comment puis-je vous aider à moderniser ou sécuriser vos applications aujourd'hui ?" }
  ];
  input = '';
  loading = false;

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        if (this.messagesContainer) {
          this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
        }
      } catch(err) { }
    }
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      setTimeout(() => this.scrollToBottom(), 0);
    }
  }

  handleSubmit() {
    if (!this.input.trim()) return;

    const userMsg = this.input;
    this.input = '';
    this.messages = [...this.messages, { role: 'user', text: userMsg }];
    this.loading = true;
    this.cdr.detectChanges();

    // Prepare history for Gemini (excluding greeting and current message)
    const history = this.messages
      .slice(0, -1) 
      .filter((msg, index) => !(index === 0 && msg.role === 'model'))
      .map(m => ({
        role: m.role,
        parts: [{ text: m.text }]
      }));

    this.http.post<any>(this.apiUrl, { message: userMsg, history }).subscribe({
      next: (data) => {
        this.messages = [...this.messages, { role: 'model', text: data.response }];
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Chat error:', error);
        this.messages = [...this.messages, { role: 'model', text: "Désolé, je rencontre une difficulté technique. N'hésitez pas à contacter Olivier directement via le formulaire." }];
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }
}